import * as yup from "yup";
export const schema = [
  yup.object({
    first_name: yup
      .string()
      .required("Please Provide The First Name")
      .max(50, "First Name cannot exceed 50 characters")
      .matches(/^[A-Za-z]+(?:\s[A-Za-z]+)*$/, "Please Enter Valid First Name"),
    phone_number: yup
      .string()
      .required("Please Provide The Phone Number 1")
      .matches(/^(?:\+91|0)?[6789]\d{9}$/, "Please enter a valid phone number.")
      .max(15, "Phone number 1 must be at most 15 digits"),
    last_name: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .max(50, "Last Name cannot exceed 50 characters")
      .test(
        "is-valid-lastname",
        "Please Enter Valid Last Name",
        (value) =>
          value === null || /^[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/.test(value)
      ),

    secondary_phone_number: yup
      .string()
      .nullable() // Allow null values (empty string)
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ) // Transform an empty string to null
      .test(
        "is-valid-phone",
        "Please provide a valid phone number",
        (value) => value === null || /^(?:\+91|0)?[6789]\d{9}$/.test(value)
      )
      .max(15, "Phone number must be at most 15 digits"),
    role_list: yup
      .string()
      .required("Please Select a Role")
      .test("not-empty", "Please Select a Role", (value) => value !== ""),
    user_name: yup
      .string()
      .required("User ID is required")
      .min(3, "User ID must be at least 3 characters")
      .max(8, "User ID must be at most 8 characters")
      .matches(
        /^[A-Za-z0-9]+$/,
        "User ID can only contain alphanumeric characters"
      ),
    // email: yup
    //   .string()
    //   .required("Email is required")
    //   .email("Please Enter a valid Email")
    //   .max(30, "email must be at most 30 characters"),
    address: yup
      .string()
      .nullable()
      .max(250, "Description must be at most 250 characters"),
    department: yup
      .string()
      .required("Please Select a Department")
      .test("not-empty", "Please Select a Department", (value) => value !== ""),
    region: yup
      .array()
      .min(1, "Region is required")
      .nullable()
      .when("$edit", (edit, schema) => {
        return edit ? schema.nullable() : schema.required("Region is required");
      }),
    userLevel: yup
      .string()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ),
  }),
];

export const CreateUserConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "first_name",
        label: "userformlabels.firstname",
        maxLength: "50",
        type: "input",
        mandatory: "true",
      },
      {
        name: "last_name",
        label: "userformlabels.lastname",
        maxLength: "50",
        type: "input",
      },
      {
        name: "role_list",
        label: "userformlabels.roles",
        type: "select",
        mandatory: "true",
        // Add default placeholder option
        defaultOption: "Select a Role",
        options: [{ value: "", label: "Select a Role" }],
      },
      {
        name: "admin_access",
        label: "User Category",
        type: "radio",
        disabled: true,
        defaultValue: "true",
        options: [
          { label: "Bank User", value: "true" },
          { label: "Branch User", value: "false" },
        ],
      },
      {
        name: "phone_number",
        label: "userformlabels.phone1",
        type: "input",
        maxLength: "15",
        mandatory: "true",
      },
      {
        name: "secondary_phone_number",
        label: "userformlabels.phone2",
        // maxLength: "15",
        type: "input",
      },
      {
        name: "user_name",
        label: "userformlabels.username", //(For ex: someone@domain.com)
        maxLength: "60",
        type: "input_username",
        mandatory: "true",
      },
      // {
      //   name: "email",
      //   label: "userformlabels.email", //(For ex: someone@domain.com)
      //   maxLength: "60",
      //   type: "input_username",
      //   mandatory: "true",
      // },
      
      {
        name: "all_banks",
        label: "userformlabels.bankname",
        type: "bankbranchselect",
        options: [],
        mandatory: "true",
        disabled: true,
      },
      {
        name: "all_branches",
        label: "userformlabels.branchname",
        type: "branchnameselect",
        options: [],
        mandatory: "true",
        disabled: true,
      },
      {
        name: "department",
        label: "userformlabels.department",
        type: "select",
        // options: [],
        mandatory: "true",
        // Add default placeholder option
        defaultOption: "Select a Department",
        options: [{ value: "", label: "Select a Department" }],
      },
      {
        name: "region",
        label: "userformlabels.region",
        type: "hier_select",
        mandatory: "true",
      },
      {
        name: "jobTitleName",
        label: "userformlabels.jobtitle",
        type: "input",
      },
      {
        name: "userLevel",
        label: "userformlabels.userLevel",
        type: "select",
        options: [
          { value: "", label: "Select" },
          { value: "L1", label: "L1" },
          { value: "L2", label: "L2" },
          { value: "L3", label: "L3" },
        ],
      },
      // {
      //   name: "address",
      //   label: "userformlabels.address",
      //   type: "text_area",
      // },
      // {
      //   name: "notification_on",
      //   label: "Send Mobile Notification",
      //   type: "checkbox",
      //   defaultValue: "true",
      // },
    ],
  },
];
